module.exports = __webpack_public_path__ + "img/lln.67c34749.jpg";